<div class="header-top" *ngIf="dmsService.albergo != null && !!dmsService.lingua">
    <div class="w-100 d-flex align-items-stretch">
        <div class="container-fluid no-gutter wrapperLogo d-flex align-items-stretch">
            <ng-container *ngIf="dmsService.pagineVisible">
                <a href="#" class="d-flex ml-4 mr-4 align-items-center" (click)="$event.preventDefault(); dmsService.pageClicked.emit(); paginaSelected = 0;" *ngIf="!!dmsService.albergo?.urlImmagineTop">
                    <img [src]="dmsService.albergo?.urlImmagineTop" class="img-fluid logoAzienda" alt="logo" title="logo">
                </a>

                <ng-container *ngIf="dmsService.pagine != null && dmsService.pagine.length > 0">
                    <a href="#" class="d-flex color-dms pr-4 pl-4 font-weight-bold pagina-link align-items-center" (click)="$event.preventDefault(); dmsService.pageClicked.emit(); paginaSelected = 0;" *ngIf="!dmsService.albergo?.urlImmagineTop">{{'dms.home' | translate}}</a>

                    <span class="d-flex d-md-none align-self-center ml-n3">
                        <button mat-icon-button [disableRipple]="true" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
                            <i class="material-icons-round pagine-dropdown">arrow_drop_down</i>
                        </button>
                    </span>

                    <mat-menu #menu="matMenu" class="pagineMenu dms-menu">
                        <ng-container *ngFor="let pagina of dmsService.pagine; let i = index;">
                            <button mat-menu-item [ngClass]="{'pagina-link-active font-weight-bold': paginaSelected == i + 1}" (click)="dmsService.pageClicked.emit(pagina); !pagina.isModale && !!pagina.testo ? paginaSelected = i + 1 : null;" *ngIf="!!pagina.nome && (!!pagina.testo || !!pagina.url)">{{pagina.nome}}</button>
                        </ng-container>
                    </mat-menu>

                    <ng-container *ngFor="let pagina of dmsService.pagine; let i = index;">
                        <a href="#" class="d-none d-md-flex color-dms pr-4 pl-4 font-weight-bold pagina-link align-items-center" [ngClass]="{'pagina-link-active': paginaSelected == i + 1}" (click)="$event.preventDefault(); dmsService.pageClicked.emit(pagina); !pagina.isModale && !!pagina.testo ? paginaSelected = i + 1 : null;"
                            *ngIf="!!pagina.nome && (!!pagina.testo || !!pagina.url)">
                            {{pagina.nome}}
                        </a>
                    </ng-container>
                </ng-container>
            </ng-container>

            <a href="#" class="d-flex color-dms pr-4 pl-4 font-weight-bold align-items-center" (click)="$event.preventDefault(); homeClick();" *ngIf="!dmsService.pagineVisible">{{'dms.home' | translate}}</a>
        </div>

        <div class="container-fluid no-gutter wrapperContattiTestata d-flex">
            <div class="contattoTestata email">
                <a class="d-flex" [href]="!!dmsService.albergo?.email ? ('mailto:' + dmsService.albergo?.email) : '#'" (click)="!dmsService.albergo?.email ? $event.preventDefault() : null">
                    <button mat-mini-fab class="dms-email-button mr-3"><i class="material-icons dms-email-icon">email</i></button>

                    <div class="infoPulsanteTestata align-self-center">
                        <strong>{{'dms.email' | translate}}</strong><br>
                        <span>{{dmsService.albergo?.email}}</span>
                    </div>
                </a>
            </div>

            <div class="contattoTestata language-select pt-0 pb-0 pr-1">
                <span class="auto-width-dms">
                    <mat-form-field class="dms-language-select">
                        <mat-select [(ngModel)]="dmsService.lingua" (ngModelChange)="utility.updateLinguaUrl(dmsService.lingua)">
                            <mat-select-trigger>
                                <span class="fi fi-{{ dmsService.selectedLanguage.flagIcon }}"></span>
                </mat-select-trigger>

                <mat-option *ngFor="let lingua of lingue" [value]="lingua.codice">
                    <span class="mr-2 fi fi-{{ lingua.flagIcon }}"></span><span>{{('language_codes.' + lingua.codice) | translate}}</span>
                </mat-option>
                </mat-select>
                </mat-form-field>
                </span>
            </div>
        </div>
    </div>
</div>